import { put } from 'redux-saga/effects';
import { connectorAdded } from '../../actions/map';
import { mapConnectorModel, getDataFromModel } from '../../../helpers/models';

export default function* addConnectorSaga(getFirebase, action) {
  const { payload: { projectId, connector } } = action;
  try {
    const newConnector = getDataFromModel(connector, mapConnectorModel);
    const addedConnector = yield getFirebase().pushWithMeta(
      `/projects/${projectId}/map/connectors`,
      newConnector,
    );
    yield put(connectorAdded(connector, addedConnector.key));
  } catch (err) {
    console.log('Error in saga!:', err);
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/map/AddConnectorSaga.js